import { IConfig } from '@cian/config/shared';
import { IAddFormService } from './addFormService';
import { IGeoService } from './geoService';

/**
 * Есть некоторое регионы (Ростов на Дону), в которых коммунальные платежи не включены в стоймость.
 *
 * Сервис следит за изменением региона и отдаёт флаг, включен ли регион в список регионов,
 * в которых коммунальные платежи не включены в стоймость.
 **/

export interface IExcludeUtilitiesTermsRegionsService {
  isUtilitiesTermsNotRequiredInRegion (): boolean;
  isFeatureToggleEnabled: boolean;
}

// tslint:disable-next-line: no-default-export
export default [
  'config', 'geoService', 'addFormService',
  (
    config: IConfig,
    geoService: IGeoService,
    addFormService: IAddFormService,
  ): IExcludeUtilitiesTermsRegionsService => {
    // Фичатогл
    const utilitiesTermsEnabled = config.getStrict<boolean>('addForm.UtilitiesTerms.Enabled');
    // Флаг определяет по какой логике работают КУ
    const useIncludeUtilitiesTermsRegions = config.getStrict<boolean>('addformConfig.useIncludeUtilitiesTermsRegions');
    // Список регионов, в которых коммунальные платежи не включены
    const excludeUtilitiesTermsRegions = config.getStrict<number[]>('addformConfig.excludeUtilitiesTermsRegions');
    // Список регионов, в которых коммунальные платежи должны быть включены
    const includeUtilitiesTermsRegions = config.getStrict<number[]>('addformConfig.includeUtilitiesTermsRegions');

    // Чистит флаги, которые должны отправиться на бек
    const setUtilitiesFlags = (isNotRequiredInRegion: boolean) => {
      const ad = addFormService.ad;
      const bargainTerms = ad && ad.bargainTerms;
      if (bargainTerms) {
        const utilitiesTerms = ad.bargainTerms.utilitiesTerms;

        if (utilitiesTerms) {
          if (isNotRequiredInRegion) {
            // Если перешли на регион, в котором коммунальные услуги НЕ включены в стоймость,
            // то должны будет передать на бек includedInPrice = false
            utilitiesTerms.includedInPrice = false;
          } else {
            // Если перешли на регион, в котором коммунальные услуги включены в стоймость,
            // то не должны передавать поле flowMetersNotIncludedInPrice
            utilitiesTerms.flowMetersNotIncludedInPrice = null;
          }
        }
      }
    };

    // Возвращает флаг, не включаются ли коммунальные услуги в стоймость в нынешнем регионе
    const isUtilitiesTermsNotRequiredInRegion = () => {
      const locationId = geoService.getLocationId();
      if (!utilitiesTermsEnabled || !locationId) {
        setUtilitiesFlags(false);

        return false;
      }
      let isNotRequiredInRegion;
      if (useIncludeUtilitiesTermsRegions) {
        isNotRequiredInRegion = !includeUtilitiesTermsRegions.includes(locationId);
      } else {
        isNotRequiredInRegion = excludeUtilitiesTermsRegions.includes(locationId);
      }

      setUtilitiesFlags(isNotRequiredInRegion);

      return isNotRequiredInRegion;
    };

    const isFeatureToggleEnabled = utilitiesTermsEnabled;

    return { isUtilitiesTermsNotRequiredInRegion, isFeatureToggleEnabled };
}];
